import styled from 'styled-components';

export const LoanStatusIcon = styled.div<{ $status: string }>`
  position: relative;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ theme, $status }) => {
      const statusLower = $status.toLowerCase();
      if (statusLower === 'current' || statusLower === 'paid_off') {
        return theme.success.background;
      }
      if (statusLower === 'charged_off') {
        return theme.warning.background;
      }
      if (statusLower === 'canceled' || statusLower === 'delinquent') {
        return theme.danger.background;
      }
      return theme.secondary.blendToBackground(800);
    }};
    box-shadow: 0 0 0 1px
      ${({ theme, $status }) => {
        const statusLower = $status.toLowerCase();
        if (statusLower === 'current' || statusLower === 'paid_off') {
          return theme.success.blendToBackground(1200);
        }
        if (statusLower === 'charged_off') {
          return theme.warning.blendToBackground(1200);
        }
        if (statusLower === 'canceled' || statusLower === 'delinquent') {
          return theme.danger.blendToBackground(1200);
        }
        return theme.secondary.blendToBackground(1200);
      }}
      inset;
  }
`;
